import './applicantReviewPage.scss';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { ThemeProvider } from '@mui/material/styles';
import { ReactNode } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Header } from '../../../components/Header/Header';
import { NavigationPane } from '../../../components/NavigationPane/NavigationPane';
import useThemeStore from '../../../store/themeStore/useThemeStore';
import useWorkflowStore from '../../../store/workflowStore/useWorkflowStore';
import { locator } from '../../../testing/e2e-locator/locator';
import EmploymentSection from './EmploymentSection';
import IncomeSection from './IncomeSection';
import PersonalSection from './PersonalSection';
import ResidenceSection from './ResidenceSection';

export function Component(): ReactNode {
  const { createTheme } = useThemeStore();
  const theme = createTheme();
  const navigate = useNavigate();

  const { t } = useTranslation();
  const { handleSubmit } = useForm();

  const {
    computed: { progress },
    next,
    previous,
  } = useWorkflowStore();

  const previousStep = (): void => {
    navigate(previous());
  };

  const formSubmit = (): void => {
    navigate(next());
  };

  return (
    <ThemeProvider theme={theme}>
      <Box className="applicant-review-page" sx={theme.pageLayout}>
        <Header
          progress={progress}
          showDrawerToggle
          onBackClick={previousStep}
        />

        <main>
          <form
            data-testid={locator.pages.applicantReview.form.root}
            noValidate
            onSubmit={handleSubmit(formSubmit)}
          >
            <div className="form-content">
              <h1 data-testid={locator.pages.applicantReview.form.h1}>
                {t('ApplicantReviewPage.title')}
              </h1>
              <h2 data-testid={locator.pages.applicantReview.form.h2}>
                {t('ApplicantReviewPage.subtitle')}
              </h2>

              <div className="content" style={{ marginBottom: '3rem' }}>
                <PersonalSection />
                <ResidenceSection />
                <EmploymentSection />
                <IncomeSection />
              </div>

              <div style={{ marginBottom: '3rem' }}>
                <Button
                  color="primary"
                  data-testid={locator.pages.applicantReview.form.submitButton}
                  startIcon={<></>}
                  type="submit"
                  variant="contained"
                  fullWidth
                >
                  {t('ApplicantReviewPage.continue')}
                </Button>
              </div>
            </div>
            <footer data-testid={locator.pages.applicantReview.footer.root}>
              {t('copyright', { year: new Date().getFullYear() })}
            </footer>
          </form>
        </main>
      </Box>

      <NavigationPane withDrawer withUserNameHeader />
    </ThemeProvider>
  );
}

Component.displayName = 'ApplicantReviewPage';
